import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GetClockTime } from '../../landing/testing/models/get-clock-time';
import { Globals } from '../../globals';
import { SocketModel } from '../../models/socket.model';
import { SocketConnectedUserModel } from './models/socket-connected-user.model';
import { LocalStorageService } from '../local-storage.service';
import { UserService } from '../user.service';
import { TdoUserConfigurationModel } from '../../models/configuration/user/tdo-user-configuration.model';
import { SocketMessageModel } from './models/socket-message.model';
import { environment } from '../../../environments/environment';

// import * as $ from "jquery"
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  static UPDATE_DOCUMENT: string = 'UPDATE_DOCUMENT';
  static UPDATE_PROFILE: string = 'UPDATE_PROFILE';
  static UPDATE_TEETH: string = 'UPDATE_TEETH';
  static REFRESH_IMAGING: string = 'REFRESH_IMAGING';
  static REFRESH_FOLDERS: string = 'REFRESH_FOLDERS';
  static UPDATE_INSURANCE_DOCUMENTS: string = 'UPDATE_INSURANCE_DOCUMENTS';

  //
  static UPDATE_PAGES: string = 'UPDATE_PAGES';
  static PAGE_SEEN: string = 'PAGE_SEEN';
  static UPDATE_CHAT_MESSAGE: string = 'UPDATE_CHAT_MESSAGE';

  baseUrl = environment.tdoSocketUrl;
  proxy: any;
  proxyName: string = 'tdo';

  // create the Event Emitter
  userDisconnected = new EventEmitter<SocketConnectedUserModel[]>();
  userConnected = new EventEmitter<SocketConnectedUserModel[]>();
  messageUser: EventEmitter<SocketMessageModel> = new EventEmitter<SocketMessageModel>();
  messageReceived: EventEmitter<SocketModel>;
  connectionEstablished: EventEmitter<boolean>;
  connectionExists: boolean;
  connectionId: string;

  private connection: any;
  messages: Subject<string> = new Subject();

  connectedUser: SocketConnectedUserModel;
  users: TdoUserConfigurationModel[];
  disconnectedUsers: TdoUserConfigurationModel[] = [];
  _connectedUsers: SocketConnectedUserModel[] = [];
  usersWereNotReady = false;

  constructor(private http: HttpClient,
    private localStorageService: LocalStorageService,
    private globals: Globals,
    private userService: UserService) {

    //
    this.connectToBroker();
    this.connectionEstablished = new EventEmitter<boolean>();
    this.messageReceived = new EventEmitter<SocketModel>();
    this.connectionExists = false;

  }

  // method to hit from client
  public sendTime(): void {

    // server side hub method using proxy.invoke with method name pass as param
    this.proxy.invoke('GetRealTime');
  }

  public sendToBackend(socketModel: SocketModel) {
    const json = JSON.stringify(socketModel.payload);
    this.proxy.invoke(socketModel.message, json);
  }

  // check in the browser console for either signalr connected or not
  connect(): void {
    const token = localStorage.getItem('TDOauthToken');
    this.connection = $.hubConnection(this.baseUrl, { qs: 'access_token=' + token });
    this.connection.headers = { Authorization: 'Bearer ' + token };
    this.proxy = this.connection.createHubProxy(this.proxyName);
    this.registerOnServerEvents();
    this.connection.start({ withCredentials: false }).done((data: any) => {
      console.log('CONNECTED TO BACKEND HUB!', data);

      this.connectionEstablished.emit(true);
      this.connectionExists = true;
      this.connectionId = data.id;

      if (this.globals.TDOCID) {
        this.userService.getUsers(this.globals.TDOCID).subscribe((usersResponse) => {
          this.users = usersResponse;
          if (this.usersWereNotReady) {
            this.usersWereNotReady = false;
            this.connectedUsers = this._connectedUsers;
          }
          if (this.users) {
            const user = this.users.find(p => p.UserID === this.localStorageService.currentUserData.authdata.userid);
            if (user) {
              user.cfgTDOUserInGroups = null;
              user.cfgTDOuserLocations = null;
              setTimeout(() => {
                this.proxy.invoke('RegisterUser', user);
              }, 1000);
            }
            this.getConnectedUsers();
          }
        });
      }
      else
        console.log('ERROR: SignalrService.connect() TDOCID not set');
    }).fail((error: any) => {
      this.connectionEstablished.emit(false);
    });
  }

  disconnect() {
    if (this.connectionEstablished && this.connectedUser) {
      const model = this.connectedUser as SocketConnectedUserModel;
      try {
        this.proxy.invoke('ForceDisconnect', this.connectionId);
      } catch (e: any) {

      }
    }
  }

  getConnectedUsers() {
    this.proxy.invoke('GetConnectedUsers');
  }

  messageAllUsers(messageType: string, object: object) {
    this.proxy.invoke('MessageAllUsers', messageType, object);
  }

  messageSingleUser(userId: string, messageType: string, object: object) {
    this.proxy.invoke('MessageUser', userId, messageType, object);
  }

  private registerOnServerEvents(): void {
    this.proxy.on('message', (data: SocketModel) => {
      this.messageReceived.emit(data);
    });

    this.proxy.on('UserConnected', (data: SocketConnectedUserModel) => {
      if (data.UserID === this.localStorageService.currentUserData.authdata.userid) {
        if (this.users) {
          this.connectedUser = this.users.find(p => p.UserID === this.localStorageService.currentUserData.authdata.userid) as SocketConnectedUserModel;
        } else {
          this.usersWereNotReady = true;
        }
      }

      this._connectedUsers.push(data);
      this.connectedUsers = this._connectedUsers;
      this.userConnected.emit(this.connectedUsers);
    });

    this.proxy.on('UserDisconnected', (userId: string) => {
      const idx = this._connectedUsers.findIndex(p => p.UserID === userId);
      if (idx > -1) {
        this._connectedUsers.splice(idx, 1);
        this.connectedUsers = this._connectedUsers;
      }
      this.userDisconnected.emit(this.connectedUsers);
    });

    this.proxy.on('AllConnectedUsers', (data: SocketConnectedUserModel[]) => {
      this.connectedUsers = data;
      this.userConnected.emit(this.connectedUsers);
    });

    this.proxy.on('MessageUser', (userId: string, messageType: string, message) => {
      const updateChatModel = new SocketMessageModel();
      updateChatModel.userId = userId;
      updateChatModel.messageType = messageType;
      updateChatModel.message = message;
      this.messageUser.emit(updateChatModel);
    });
  }

  set connectedUsers(users: SocketConnectedUserModel[]) {
    this._connectedUsers = users;
    const connectedIds = this._connectedUsers.map(p => p.UserID);
    if (this.users) {
      this.disconnectedUsers = this.users.filter(p => !connectedIds.includes(p.UserID));
    }
  }

  get connectedUsers() {
    return this._connectedUsers;
  }

  connectToBroker() {

    console.log('SignalR Service connectToBroker');
    const cnx = $.hubConnection('http://localhost:8000');
    const proxy = cnx.createHubProxy('TdoHub');


    proxy.on('AddMessage', (m: string, message: string) => {
      console.log('From broker to: ' + m + ' Message: ' + message);
    });
    proxy.on('brokerImageData', (data: string) => {
      const updateChatModel = new SocketMessageModel();
      updateChatModel.messageType = 'brokerImageData';
      updateChatModel.message = data as unknown as object;
      this.messageUser.emit(updateChatModel);
    });
    cnx.start({ withCredentials: false }).done((data: any) => {
      console.log('CONNECTED TO SERVICE BROKER!');
    });
  }
}
